<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2021-02-23 17:58:55
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-01-22 14:30:03
 * @FilePath: /platform/src/views/common/Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-container>
    <div class="topColumns">
      <el-row v-for="(item, i) in topColumns" :key="i" class="eachTop">
        <div style="padding: 0 16px">
          <p class="topColumnsTitle">{{ item.title }}</p>
          <el-col :span="3" v-for="(val, v) in item.list" :key="v" class="eachCol" @click.native="checkWhereGo(val)">
            <p class="eachColNum">{{ val.num }}</p>
            <p class="eachColName">{{ val.type_name }}</p>
          </el-col>
        </div>
      </el-row>
      <div class="eachTop2">
        <div class="eachTopp" style="margin-right: 10px">
          <p class="topColumnsTitle">业务规划</p>

          <div class="eachHalfs">
            <div v-for="(item, i) in planList" :key="i" class="eachHalf" @click="goDetailPage(item.router, item.active)">
              <div class="flexL">
                <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="item.icon"></use>
                </svg>
                <p>{{ item.type_name }}</p>
              </div>
              <div class="flexR">{{ item.num }}</div>
            </div>
          </div>
        </div>
        <div class="eachTopp">
          <p class="topColumnsTitle">提醒事项</p>
          <div class="eachHalfs">
            <div v-for="(item, i) in remindList" :key="i" class="eachHalf" @click="goDialogTable(item, item.type)">
              <div class="flexL">
                <svg class="icon svg-icon" aria-hidden="true">
                  <use :xlink:href="item.icon"></use>
                </svg>
                <p>{{ item.type_name }}</p>
              </div>
              <div class="flexR">{{ item.num }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="eachTop">
        <div style="padding: 0 16px">
          <p class="topColumnsTitle">计费中心</p>
          <el-link type="primary" :underline="false" @click="goDetailPage('billing_center_inner')" class="posiAbLink">查看详情</el-link>
          <el-table
            :data="moduleList.filter((x) => ['1', '3', '8', '10', '12', '13', '14'].includes(String(x.account_module)))"
            border
            :header-cell-style="headerCellStyle"
            style="width: 100%"
          >
            <el-table-column prop="account_module" align="center" label="模块">
              <template slot-scope="scope">
                {{ typeListTrans(scope.row.account_module) }}
              </template>
            </el-table-column>
            <el-table-column prop="open_status" align="center" label="是否开通">
              <template slot-scope="scope">
                <el-tag :type="scope.row.open_status == 1 ? 'success' : 'warning'">{{ scope.row.open_status == 1 ? '已开通' : '未开通' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="initial_open_time" align="center" label="开通日期">
              <template slot-scope="scope">
                {{ scope.row.open_status == 0 ? '—' : scope.row.initial_open_time ? scope.row.initial_open_time : '—' }}
              </template>
            </el-table-column>
            <el-table-column prop="expire_time" align="center" label="到期时间">
              <template slot-scope="scope">
                {{ scope.row.open_status == 0 ? '—' : scope.row.expire_time ? scope.row.expire_time : '—' }}
              </template>
            </el-table-column>
            <el-table-column prop="remain" label="剩余量" align="center">
              <template slot-scope="scope">
                {{ scope.row.open_status == 0 ? '—' : getReturnRemain(scope.row) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="eachTop">
        <div style="padding: 0 16px">
          <p class="topColumnsTitle">流程统计</p>
          <p class="posiAbLink">启用流程：{{ startFlowNum }}</p>
          <el-table :data="flowList" border :header-cell-style="headerCellStyle" style="width: 100%">
            <el-table-column prop="name" align="center" label="流程"> </el-table-column>
            <el-table-column label="本月" align="center">
              <el-table-column prop="month_num" align="center" label="数量"> </el-table-column>
              <el-table-column prop="month_duration" align="center" label="平均时长(天)"> </el-table-column>
            </el-table-column>
            <el-table-column label="本年" align="center">
              <el-table-column prop="year_num" align="center" label="数量"> </el-table-column>
              <el-table-column prop="year_duration" align="center" label="平均时长(天)"> </el-table-column>
            </el-table-column>
          </el-table>
          <div class="borderBox">
            <p class="topColumnsTitle">流程实例趋势</p>
            <div class="positionAb">
              <div>
                <p></p>
                <span>新增</span>
              </div>
              <div>
                <p class="red"></p>
                <span>结束</span>
              </div>
            </div>
            <div id="echartsLine1" style="height: 100%"></div>
          </div>
          <div class="borderBox" style="height: auto">
            <p class="topColumnsTitle">超一天未审批流程</p>
            <el-table :data="overFlowList" border :header-cell-style="headerCellStyle" style="width: 100%">
              <el-table-column type="index" align="center" label="序号" width="50"> </el-table-column>
              <el-table-column prop="procDefName" align="center" label="流程名称"> </el-table-column>
              <el-table-column prop="subject" show-overflow-tooltip align="center" label="流程标题"> </el-table-column>
              <el-table-column prop="instCreateTime" align="center" label="流程发起时间"> </el-table-column>
              <el-table-column prop="assigneeName" align="center" label="审批人"> </el-table-column>
              <el-table-column prop="createTime" align="center" label="当前节点开始时间"> </el-table-column>
              <el-table-column prop="approveTime" align="center" label="当前节点审批时间(天)"> </el-table-column>
            </el-table>
            <div style="text-align: right">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="total, prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="eachTop">
        <div style="padding: 0 16px; position: relative">
          <p class="topColumnsTitle">日访问情况</p>
          <div class="positionAb" style="top: -8px">
            <div>
              <p class="square"></p>
              <span>日访问量</span>
            </div>
            <div>
              <p class="red"></p>
              <span>日活跃用户数</span>
            </div>
            <div>
              <p class="green"></p>
              <span>日活跃页面数</span>
            </div>
          </div>
          <div id="echartsLine2" style="height: 245px"></div>
        </div>
      </div>
      <foot-part />
    </div>
    <!-- 在线用户列表 -->
    <online-user-record-dialog v-if="showOnlineUserDialog" :tenantId="tenantId" :show="showOnlineUserDialog" @closeOnlineUserRecord="closeOnlineUserRecord" />
    <transfer-dialog ref="transDialogRef" />
  </el-container>
</template>
<script>
import echarts from 'echarts'
import uc from '@/api/uc'
import onlineUserRecordDialog from '../form/billingCenter/onlineUserRecordDialog.vue'
import { typeList, handleType } from '../form/billingCenter/constants.js'
import moment from 'moment'
import FootPart from '../../components/common/footPart.vue'
import TransferDialog from './transferDialog.vue'
export default {
  components: { onlineUserRecordDialog, FootPart, TransferDialog },
  data() {
    return {
      typeList,
      tenantId: '',
      showOnlineUserDialog: false,
      dialogType: '',
      topColumns: [
        {
          title: '基本信息',
          list: [
            { type: '1', router: 'tenantInfoManager', active: 'corporateInfo' },
            { type: '2', router: 'tenantInfoManager', active: 'bankInfo' },
            { type: '3', router: 'organization', active: 'orgManager' },
            { type: '4', router: 'organization', active: 'postManager' },
            { type: '5', router: 'organization', active: 'jobManage' },
            { type: '6', router: 'roleManager' },
            { type: '7', router: 'ucManager' },
            { type: '8', type_name: '在线用户' }
          ]
        },
        {
          title: '模版配置',
          list: [
            { type: '1', router: 'htmbManageList' },
            { type: '2', router: 'htmbManageList' },
            { type: '3', router: 'constructionProcedureTemplate' },
            { type: '4', router: 'managementPlanTemplate' },
            { type: '5', router: 'costAccountTemplate' },
            { type: '6', router: 'watermarkTemplate' },
            { type: '7', router: 'financeExternal', active: 'sysNcTemplate' },
            { type: '8', router: 'approvalReportTemplate' }
          ]
        }
      ],
      planList: [
        {
          icon: '#icon-zhinengshenheguizeshu',
          router: 'ruleConfigManager',
          type: '1'
        },
        {
          icon: '#icon-kemuguizeyipeizhi',
          router: 'OCR_expense_account',
          type: '2'
        },
        {
          icon: '#icon-fengxianguizeyipeizhi',
          router: 'noticeRules',
          type: '3'
        },
        {
          icon: '#icon-gongnengkaiqishu',
          router: 'businessRulesSwitch',
          type: '4'
        },
        {
          icon: '#icon-kuozhanziduanshu',
          router: 'bdqx',
          type: '5'
        }
      ],
      remindList: [
        {
          icon: '#icon-gangweiweikong',
          type: '1'
        },
        {
          icon: '#icon-jiaoseweifenpeiyonghu',
          type: '2'
        },
        {
          icon: '#icon-yonghugangweiweikong',
          type: '3'
        },
        {
          icon: '#icon-yonghujiaoseweikong',
          type: '4'
        },
        {
          icon: '#icon-liuchengjiedianshenpirenweikong',
          type: '5'
        }
      ],
      moduleList: [],
      startFlowNum: 0,
      flowList: [],
      currentPage: 1,
      total: 0,
      overFlowList: []
    }
  },
  mounted() {
    this.$store.dispatch('menu/removeHasLeft', false)
    let currentTenantId = sessionStorage.currentTenantId
    this.tenantId = currentTenantId == '-1' ? '' : currentTenantId
    this.getData()
  },
  methods: {
    // 剩余量
    getReturnRemain(module) {
      switch (String(module.account_module)) {
        case '1':
          if (module.remainDays) return module.remainDays + '天'
          else return '—'
          break
        case '3':
          if (module.total_times !== null) return module.total_recharge - module.total_times + '次'
          else return '—'
          break
        case '8':
          if (module.total_times !== null) return module.total_recharge - module.total_times + '次'
          else return '—'
          break
        case '10':
          if (module.total_times !== null) return module.total_recharge - module.total_times + '次'
          else return '—'
          break
        case '12':
          if (module.total_user !== null) return module.total_user - module.userCount + '个用户'
          else return '—'
          break
        case '13':
          if (module.total_times !== null) return module.total_recharge - module.total_times + '个项目'
          else return '—'
          break
        case '14':
          if (module.remainDays) return module.remainDays + '天'
          else return '—'
          break
      }
    },
    //在线用户弹框关闭
    closeOnlineUserRecord() {
      this.showOnlineUserDialog = false
    },

    // 超一天未审批流程
    getOverFlowList() {
      const yDay = moment(new Date()).subtract(1, 'day').endOf('day').format('YYYY-MM-DD')
      const nTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss').split(' ')[1]
      const yesterday = yDay + ' ' + nTime
      const param = {
        pageBean: { page: this.currentPage, pageSize: 10, total: 0 },
        querys: [
          {
            property: 'createTime',
            value: yesterday,
            group: 'main',
            operation: 'LESS_EQUAL',
            relation: 'AND'
          }
        ],
        sorter: [{ property: 'createTime', direction: 'ASC' }]
      }
      this.$http.post('${bpmRunTime}/runtime/task/v1/list', param).then((res) => {
        this.total = res.data.total
        res.data.rows &&
          res.data.rows.forEach((e) => {
            e.approveTime = moment(new Date()).diff(e.createTime, 'days', true).toFixed(2)
          })

        this.overFlowList = res.data.rows
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getOverFlowList()
    },
    // 流程实例趋势
    initChart() {
      this.$http.get('${data}/back/statistics/getBpmInstTrend').then((res) => {
        const monthArr = [
          {
            idx: 0,
            month: 'jan'
          },
          { idx: 1, month: 'feb' },
          { idx: 2, month: 'mar' },
          { idx: 3, month: 'apr' },
          { idx: 4, month: 'may' },
          { idx: 5, month: 'june' },
          { idx: 6, month: 'july' },
          { idx: 7, month: 'aug' },
          { idx: 8, month: 'sept' },
          { idx: 9, month: 'oct' },
          { idx: 10, month: 'nov' },
          { idx: 11, month: 'dece' }
        ]
        const data1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        const data2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        monthArr.forEach((o) => {
          data1[o.idx] = res.data[0][o.month]
          data2[o.idx] = res.data[1][o.month]
        })
        let chart = echarts.getInstanceByDom(document.getElementById('echartsLine1'))
        if (chart == null) {
          chart = echarts.init(document.getElementById('echartsLine1'))
        }
        let myOption = {
          xAxis: {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '15',
            right: '15',
            top: '30',
            containLabel: true
          },
          yAxis: {
            type: 'value',
            name: '数量',
            nameLocation: 'end',
            splitLine: {
              //分割线配置
              show: true,
              lineStyle: {
                color: '#F6F6F6'
              }
            }
          },
          series: [
            {
              name: '新增',
              data: data1,
              type: 'line',
              itemStyle: {
                color: '#155BD4'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(21,91,212,0.2)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(185,211,255,0.2)'
                  }
                ])
              }
            },
            {
              name: '结束',
              data: data2,
              type: 'line',
              itemStyle: {
                color: '#FF453A'
              },

              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(255, 69, 58, 0.2)'
                  },
                  {
                    offset: 1,
                    color: 'RGBA(255, 219, 217, 1)'
                  }
                ])
              }
            }
          ]
        }

        chart.setOption(myOption)
      })
    },
    // 日访问量
    getLogList() {
      this.$http.get('${data}/back/statistics/getDailyVisits').then((res) => {
        const arr = res.data
        const monthArr = arr.map((o) => {
          return o.spe_date
        })
        const dayVisitArr = arr.map((o) => {
          return o.daily_visits
        })
        const dayActiveVisitArr = arr.map((o) => {
          return o.daily_active_users
        })
        const dayPageArr = arr.map((o) => {
          return o.daily_active_pages
        })
        const twoArr = [].concat(dayActiveVisitArr, dayPageArr)
        let Max1, Max2
        Max1 = this.calMax(dayVisitArr)
        Max2 = this.calMax(twoArr)
        let chart2 = echarts.getInstanceByDom(document.getElementById('echartsLine2'))
        if (chart2 == null) {
          chart2 = echarts.init(document.getElementById('echartsLine2'))
        }
        let myOption2 = {
          xAxis: {
            type: 'category',
            data: monthArr
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '15',
            right: '15',
            top: '35',
            bottom: '0',
            containLabel: true
          },
          yAxis: [
            {
              type: 'value',
              name: '数量',
              nameLocation: 'end',
              min: 0,
              max: Max1,
              interval: Max1 / 5,
              splitLine: {
                //分割线配置
                show: true,
                lineStyle: {
                  color: '#F6F6F6'
                }
              }
            },
            {
              type: 'value',
              splitNumber: 5,
              name: '数量',
              min: 0,
              max: Max2,
              interval: Max2 / 5,
              nameLocation: 'end',
              splitLine: {
                //分割线配置
                show: true,
                splitNumber: 5,
                lineStyle: {
                  color: '#F6F6F6'
                }
              }
            }
          ],

          series: [
            {
              name: '日访问量',
              data: dayVisitArr,
              barWidth: 12,
              yAxisIndex: 0,
              type: 'bar',
              itemStyle: {
                color: '#155BD4'
              }
            },
            {
              name: '日活跃用户数',
              data: dayActiveVisitArr,
              yAxisIndex: 1,
              type: 'line',
              itemStyle: {
                color: '#E78319'
              }
            },
            {
              name: '日活跃页面数',
              data: dayPageArr,
              yAxisIndex: 1,
              type: 'line',
              itemStyle: {
                color: '#23AF46'
              }
            }
          ]
        }

        chart2.setOption(myOption2)
      })
    },
    checkWhereGo(val) {
      if (val.router) this.goDetailPage(val.router, val.active)
      else this.goDialogTable(val, val.type_name)
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
      return obj
    },
    /**
     * @description:
     * @param {*} item
     * @param {*} type
     * @return {*}
     */
    goDialogTable(item, type) {
      if (type == '在线用户') this.showOnlineUserDialog = true
      else {
        this.dialogType = String(type)
        this.$refs.transDialogRef.open(this.dialogType)
      }
    },
    /**
     * @description: 跳转页面
     * @param {*} router
     * @param {*} active
     * @return {*}
     */
    goDetailPage(router, active) {
      this.$router.push({
        name: router,
        params: {
          active: active
        }
      })
    },
    /**
     * @description: 管理后台首页-获取租户基本信息看板
     * @return {*}
     */
    getBasicBoardVo() {
      this.$http.get('${data}/back/statistics/getBasicBoardVo').then((res) => {
        res.data.forEach((e) => {
          const index = this.topColumns[0].list.findIndex((o) => o.type == e.type)
          if (index > -1) {
            e.num = e.quantity
            e.router = this.topColumns[0].list[index].router
            e.active = this.topColumns[0].list[index].active
            this.$set(this.topColumns[0].list, index, e)
          }
        })
        uc.getOnlineUserCount(this.tenantId).then((resp) => {
          const index = this.topColumns[0].list.find((o) => o.type == '8')
          if (index) {
            index.num = resp.value
            this.$set(this.topColumns[0].list, 7, index)
          }
        })
      })
    },
    // 双 y刻度设置
    calMax(arr) {
      //计算最大值
      let maxA = Math.max(...arr) // 最大值A
      let maxint = Math.ceil(maxA / 5) //最大平均值（向上取整）= 最大值A / 间隔数
      let maxB = maxint * 5 // 最大值B = 最大平均值 * 间隔数  （注：最大值B>最大值A）
      return Math.max(maxB, 5) // 为了防止maxB数据为0时，Y轴不显示，给个默认最大值10
    },
    /**
     * @description: 管理后台首页-模版配置
     * @return {*}
     */
    getTemplateBoardVo() {
      this.$http.get('${data}/back/statistics/getTemplateBoardVo').then((res) => {
        res.data.forEach((e) => {
          const index = this.topColumns[1].list.findIndex((o) => o.type == e.type)
          if (index > -1) {
            e.num = e.quantity
            e.router = this.topColumns[1].list[index].router
            e.active = this.topColumns[1].list[index].active
            this.$set(this.topColumns[1].list, index, e)
          }
        })
      })
    },
    /**
     * @description: 管理后台首页-获取业务规则看板
     * @return {*}
     */
    getRuleBoardVo() {
      this.$http.get('${data}/back/statistics/getRuleBoardVo').then((res) => {
        res.data.forEach((e) => {
          const index = this.planList.findIndex((o) => o.type == e.type)
          if (index > -1) {
            e.num = e.quantity
            e.icon = this.planList[index].icon
            e.router = this.planList[index].router
            e.active = this.planList[index].active
            this.$set(this.planList, index, e)
          }
        })
      })
    },
    /**
     * @description: 管理后台首页-获取提醒事项看板
     * @return {*}
     */
    getReminderBoardVo() {
      this.$http.get('${data}/back/statistics/getReminderBoardVo').then((res) => {
        res.data.forEach((e) => {
          const index = this.remindList.findIndex((o) => o.type == e.type)
          if (index > -1) {
            e.num = e.quantity
            e.icon = this.remindList[index].icon
            this.$set(this.remindList, index, e)
          }
        })
      })
    },
    /**
     * @description: 流程统计
     * @return {*}
     */
    getBpmNode() {
      this.$http.get('${data}/back/statistics/getBpmNode').then((res) => {
        if (res.data) {
          this.startFlowNum = res.data.num
          this.flowList = [
            {
              name: res.data.name,
              month_num: res.data.month_num,
              month_duration: res.data.month_duration,
              year_duration: res.data.year_duration,
              year_num: res.data.year_num
            }
          ]
        }
      })
    },
    /**
     * @description: 获取计费中心
     * @return {*}
     */
    getModuleList() {
      this.$http.get('${third}/system/account_mangement/getById?tenantId=' + this.tenantId).then((res) => {
        this.moduleList = res.data.filter((x) => this.typeList.find((itemsMenu) => x.account_module == itemsMenu.code))
      })
    },
    typeListTrans(data) {
      let temp = this.typeList.find((item) => item.code == data)
      return temp ? temp.name : ''
    },
    /**
     * @description: 获取数据
     * @return {*}
     */
    getData() {
      this.getBasicBoardVo()
      this.getTemplateBoardVo()
      this.getRuleBoardVo()
      this.getReminderBoardVo()
      this.getModuleList()
      this.getBpmNode()
      this.initChart()
      this.getOverFlowList()
      this.getLogList()
    }
  }
}
</script>
<style lang="scss" scoped>
.topColumns {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.eachTop {
  position: relative;
  padding: 14px 0;
  background: #ffffff;
  border-bottom: 10px solid #f2f3f5;
  width: 100%;
}
.topColumnsTitle {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  margin: 0 0 14px;
}

.eachColNum {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin: 0 0 2px;
}
.eachColName {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c90;
  line-height: 20px;
  margin: 0;
}
.eachCol {
  cursor: pointer;
}
.eachCol:hover {
  .eachColNum {
    color: #155bd4;
  }
}
.eachTop2 {
  width: 100%;
  background: #f2f3f5;
  border-bottom: 10px solid #f2f3f5;
  display: flex;
  .eachTopp {
    background: #fff;
    padding: 14px 16px;
    width: calc((100% - 10px) / 2 - 32px);
  }
}
.positionAb {
  position: absolute;
  right: 20px;
  top: 10px;
  display: flex;
  div {
    display: flex;
    align-items: center;
    margin-left: 30px;
    p {
      border-radius: 50%;
      width: 6px;
      height: 6px;
      background: #155bd4;
      margin-right: 6px;
    }
    span {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    .square {
      border-radius: 0;
    }
    .red {
      background: #ff453a;
    }
    .green {
      background: #23af46;
    }
  }
}
.eachHalfs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.eachHalf {
  width: calc((100% - 10px) / 2);
  height: 50px;
  background: rgba(242, 243, 245, 0.8);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 10px;
}
.flexL {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 16px;
  .icon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
}
.flexR {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 20px;
  margin-right: 16px;
}
.eachHalf:hover {
  .flexR {
    color: #155bd4;
  }
}
.posiAbLink {
  position: absolute;
  top: 16px;
  right: 18px;
  margin: 0;
}
.borderBox {
  margin-top: 20px;
  border: 1px solid #e0e0e0;
  height: 300px;
  padding: 17px;
  position: relative;
}
/deep/.el-table td {
  border-color: #e0e0e0;
}
/deep/.el-table--border {
  border: 1px solid #e0e0e0;
}
.foot {
  padding: 0 0 10px;
}
/deep/:focus {
  outline: 0;
}
</style>
